module.exports = __webpack_public_path__ + "media/images/Candle-Holder-Empty-Test1-0ebc24c9046510a1138029bb3f14067c.png";